import { useState } from 'react'

import TabsKsGuru from 'app/KinerjaShared/components/TabsKsGuru'

import type { TabFilterRoles } from 'types/kinerja-ks'
import type {
  TabsKsTabDetail,
  TabsKsGuruProps,
} from 'app/KinerjaShared/components/TabsKsGuru'

type Props = TabsKsGuruProps & {
  hideTabGuru?: boolean

  // Will be use to initialize the counters, without this, the counters will not be displayed upon first render
  initCounters?: Record<TabFilterRoles, number>

  // Callback function when tab is changed
  onChange?: (tab: TabsKsTabDetail) => void

  // Optional custom labels for KS and Guru tabs
  ksLabel?: string
  guruLabel?: string
}

type TabKsGuru = {
  activeTab: TabsKsTabDetail
  activeTabIndex: number
  activeTabName: TabFilterRoles
  render: JSX.Element
  setCounters: (counters: Record<TabFilterRoles, number>) => void
}

const useTabKsGuru = (props?: Props): TabKsGuru => {
  const [counters, setCounters] = useState<Record<TabFilterRoles, number>>(
    props?.initCounters || null
  )

  const [activeTab, setActiveTab] = useState<TabsKsTabDetail>({
    name: 'KS',
    index: 0,
  })

  // Function to handle tab change
  const onTabChanged = (tab: TabsKsTabDetail) => {
    setActiveTab(tab)
  }

  return {
    activeTab,
    activeTabIndex: activeTab.index,
    activeTabName: activeTab.name as TabFilterRoles,
    setCounters,
    render: (
      <TabsKsGuru
        {...props}
        counters={counters}
        onChange={(tab) => {
          onTabChanged(tab)

          props?.onChange?.(tab)
        }}
      />
    ),
  }
}

export default useTabKsGuru
